export const DEFAULT_LAYOUT_ID = "bonusx-default-layout";
export const DEFAULT_LAYOUT_CONTENT_ID = "bonusx-default-layout-content";
